import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { switchMap, catchError, of, map } from 'rxjs';
import * as TicketActions from './ticket.actions';
import { ToteWageringAPIService } from '@amwager/data-access';
import { fetch } from '@nx/angular';
import { WagerFacade } from '@amwager/wager/data-access';

@Injectable()
export class TicketEffects {

  constructor(
    private readonly actions$: Actions,
    private readonly toteWageringAPIService: ToteWageringAPIService,
    private readonly wagerFacade: WagerFacade
  ) {}

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TicketActions.initTicketState),
      switchMap(() => of(TicketActions.loadTicketStateSuccess())),
      catchError((error) => {
        console.error('Error', error);
        return of(TicketActions.loadTicketStateFailure({ error }));
      })
    )
  );

  getCounters$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TicketActions.getCountersAPI),
      fetch({
        id: () => 'getCounters',
        run: ({ runId }) => this.toteWageringAPIService.getCounters$(runId)
          .pipe(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            map((response: any) => {

              try {
                // eslint-disable-next-line no-unsafe-optional-chaining
                if ("Model" in response) {
                  response = response?.Model;
                }
              } catch (error) {
                console.error("Model:API");
              }

              setTimeout(() => {
                this.wagerFacade.updateResultsPersonalStatistics(
                  'TicketEffects:getCounters',
                  response
                );
              }, 500);

              return TicketActions.getCountersAPISuccess({ successResponse: response });
            })
          )
        ,
        // eslint-disable-next-line no-empty-pattern
        onError: ({}, errorResponse) => TicketActions.getCountersAPIFailed({ errorResponse }),
      })
    )
  );

}
